/** Lê o token de login do checkout e tira da URL (query ou hash) na hora. */
export function consumeCheckoutLoginToken(): string | null {
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const fromHash = new URLSearchParams(hash).get("token");
  const fromQuery = new URLSearchParams(window.location.search).get("token");
  const raw = (fromHash || fromQuery)?.replaceAll(" ", "") ?? null;

  if (fromHash || fromQuery) {
    const url = new URL(window.location.href);
    url.searchParams.delete("token");
    url.hash = "";
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}`
    );
  }

  if (!raw) {
    return null;
  }

  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
